/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from 'react';
import LogRocket from 'logrocket';
import { createRoot } from 'react-dom/client';
import App from '@component/App';
import * as Sentry from '@sentry/react';
import store from '@lib/store';
import { IAppError } from '@types';

const supportBase = 'http://support.vigilantmedicalsolutions.com/en/articles/';
const installArticle = '5269291-first-steps';
const privacyArticle = '5296943-privacy-policy';
const redirectToArticle = (article: string) => window.location.assign(`${supportBase}${article}`);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    beforeSend(
      event,
      {
        originalException: error,
      }: { originalException: IAppError | string | null },
    ) {
      if (error && typeof error !== 'string') {
        error.pushed = true;
        store.errors.push(error);
      }

      return event;
    },
    dsn: 'https://7fc239d5a01b4693ad28a3f6c8d2d718@o48728.ingest.sentry.io/5473442',
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.01,
  });

  LogRocket.init('5xd3tx/guardian', {
    network: {
      // Every API call carries the session credential in an `auth` header, and
      // the WebSocket URL carries it in a query string. Unsanitised, LogRocket
      // recorded both verbatim into a replayable session — anyone with access
      // to the recordings held working credentials for the account being
      // recorded. The login code goes the same way on the sign-in request.
      requestSanitizer: request => {
        if (request.headers?.auth) request.headers.auth = '[REDACTED]';
        if (request.url?.includes('auth=')) {
          request.url = request.url.replace(/auth=[^&]*/g, 'auth=[REDACTED]');
        }
        if (request.body && /"otp"/.test(String(request.body))) {
          request.body = '[REDACTED]';
        }
        return request;
      },
      // Responses to the login endpoints contain the freshly minted token.
      responseSanitizer: response => {
        if (response.body && /"auth"/.test(String(response.body))) {
          response.body = '[REDACTED]';
        }
        return response;
      },
    },
  });

  LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
      scope.setExtra('sessionURL', sessionURL);
    });
  });
}

// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept();

  // @ts-ignore
  module.hot.addStatusHandler((status: string) => {
    // eslint-disable-next-line no-console
    if (status === 'prepare') console.clear();
  });
}

if (window.location.hostname.match(/^install\./)) {
  redirectToArticle(installArticle);
} else if (window.location.pathname === '/privacy') {
  redirectToArticle(privacyArticle);
} else {
  createRoot(document.getElementById('root')).render(<App />);
}
